module.exports = __webpack_public_path__ + "images/back-to-top-hover.svg";